export default __webpack_public_path__ + "4ecaa533bc14eaededbecb0ae0c5f62c.png";